import { makeStyles } from '@fluentui/react-components';

export const useAccessReviewStyles = makeStyles({
    // Common layout styles
    accessReviewFlexColumnWithGap: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
    },
    
    // Page-specific styles
    accessReviewContainer: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: '15px',
    },
    accessReviewContentContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        padding: '24px',
        backgroundColor: '#ffffff',
        borderRadius: '6px',
        border: '1px solid #e0e0e0',
    },
    accessReviewButtonContainer: {
        display: 'flex',
        gap: '12px',
        marginTop: '24px',
        justifyContent: 'center',
    },
    accessReviewErrorText: {
        color: '#d13438',
        padding: '12px',
        backgroundColor: '#fef0f0',
        borderRadius: '4px',
        fontSize: '14px',
    },
    accessReviewParagraphDropdown: {
        '& button': {
            fontSize: '15px',
        },
    },
    accessReviewParagraphOption: {
        fontSize: '15px',
        maxWidth: '500px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
});
